import React, { useEffect, useState } from "react";
import axios from "axios";
import WalletConnect from "./WalletConnect";
import Leaderboard from "./Leaderboard";
import DonationBic from "./DonationBic";

const ProgressBar = () => {
  const [balanceKAS, setBalanceKAS] = useState(0);
  const [balanceKOONUSD, setBalanceKOONUSD] = useState(0);
  const [balanceKOON, setBalanceKOON] = useState(0);
  const [valueKASInUSD, setValueKASInUSD] = useState(0);
  const goalKAS = 120000;
  const goalUSD = 15000;

  useEffect(() => {
    const fetchBalanceKAS = async () => {
      try {
        const response = await axios.get(
          "https://api.kaspa.org/addresses/kaspa%3Aqzk0z20m7sm7rm35yvzpuv8a5pzlzgur5yn90f65lm4err50ujn9s8pr6ltpz/balance"
        );
        const balanceInKAS = response.data.balance / 1e8;
        setBalanceKAS(balanceInKAS);

        const kasPriceResponse = await axios.get(
          "https://api.kaspa.org/info/price?stringOnly=false"
        );
        const kasPriceInUSD = kasPriceResponse.data.price;

        const valueInUSD = balanceInKAS * kasPriceInUSD;
        setValueKASInUSD(valueInUSD);
      } catch (error) {
        console.error("Erreur lors de la récupération du solde KAS :", error);
      }
    };

    const fetchBalanceKOON = async () => {
      try {
        const balanceResponse = await axios.get(
          "https://api.kasplex.org/v1/krc20/address/kaspa%3Aqzk0z20m7sm7rm35yvzpuv8a5pzlzgur5yn90f65lm4err50ujn9s8pr6ltpz/token/KOON"
        );
        console.log(balanceResponse);
        const tokenBalance = balanceResponse.data.result[0].balance;
        const balanceInKOON = tokenBalance / 1e8;
        setBalanceKOON(balanceInKOON);

        const priceResponse = await axios.get(
          "https://api-v2-do.kas.fyi/token/krc20/transactions?ticker=KOON"
        );
        const floorPrice =
          priceResponse.data.results[0].tokenInfo.price.floorPrice;

        const valueInKAS = balanceInKOON * floorPrice;

        const kasPriceResponse = await axios.get(
          "https://api.kaspa.org/info/price?stringOnly=false"
        );
        const kasPriceInUSD = kasPriceResponse.data.price;

        const valueInUSD = valueInKAS * kasPriceInUSD;

        setBalanceKOONUSD(valueInUSD);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de la valeur KOON :",
          error
        );
      }
    };

    fetchBalanceKAS();
    fetchBalanceKOON();
  }, []);

  const progressPercentageKAS = Math.min((balanceKAS / goalKAS) * 100, 100);
  const progressPercentageUSD = Math.min((balanceKOONUSD / goalUSD) * 100, 100);

  const address =
    "kaspa:qzk0z20m7sm7rm35yvzpuv8a5pzlzgur5yn90f65lm4err50ujn9s8pr6ltpz";

  const handleCopy = () => {
    navigator.clipboard.writeText(address).then(
      () => {
        alert("Address copied to clipboard!");
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  return (
    <div id="donation" className="donation section">
      <img
        src="./images/bg_donation.png"
        alt="Koon race"
        className="bg_donation"
      />
      <div className="container mx-auto">
        <div className="title dark">
          <h1>Donation</h1>
          <img src="/images/claw_title.png" alt="Claw" className="claw-title" />
        </div>

        <p className="txt">
          Donations are essential to our project's growth, helping us reach new
          heights. Your support enables us to secure listings on CEX/DEX
          platforms, making our token more accessible. It covers server costs,
          ensuring smooth operations, and allows us to collaborate with talented
          artists, enriching our project's visual appeal. Donations also empower
          us to partner with key opinion leaders (KOLs) and run impactful
          marketing campaigns, spreading our vision to a broader audience. As a
          special thank you, the top donors will have the privilege of receiving
          an exclusive <span>Koon NFT</span>, a symbol of their invaluable
          contribution. Every contribution brings us closer to our goals and
          strengthens our community.
        </p>

        <DonationBic />

        <div className="progressbar_container">
          <h3 className="progressbar_title">Pre-listing</h3>
          <div className="progressbar_bg bg-gray-300 rounded-full h-9 mb-4">
            <div
              className="progressbar_fill text-xs font-medium text-center text-blue-100 flex items-center justify-center h-full rounded-full"
              style={{ width: "100%" }}
            >
              100%
            </div>
          </div>
          <div className="progressbar_goal">
            <div className="progressbar_goal_item">
              <span>Goal</span>
              <p>$10,000</p>
            </div>
            <div className="progressbar_goal_item">
              <span>Koontribution</span>
              <p>$10,000</p>
            </div>
          </div>
        </div>

        <div className="progressbar_container">
          <h3 className="progressbar_title">KAS donation progress</h3>
          <div className="progressbar_bg bg-gray-300 rounded-full h-9 mb-4">
            <div
              className="progressbar_fill text-xs font-medium text-center text-blue-100 flex items-center justify-center h-full rounded-full"
              style={{ width: `${progressPercentageKAS}%` }}
            >
              {progressPercentageKAS.toFixed(2)}%
            </div>
          </div>
          <div className="progressbar_goal">
            <div className="progressbar_goal_item">
              <span>Goal</span>
              <p>{goalKAS.toLocaleString()} KAS ($15,000)</p>
            </div>
            <div className="progressbar_goal_item">
              <span>Koontribution</span>
              <p>
                {balanceKAS.toLocaleString()} KAS (${valueKASInUSD.toFixed(2)})
              </p>
            </div>
          </div>
        </div>

        <div className="progressbar_container">
          <h3 className="progressbar_title">KOON donation progress</h3>
          <div className="progressbar_bg bg-gray-300 rounded-full h-9 mb-4">
            <div
              className="progressbar_fill text-xs font-medium text-center text-green-100 flex items-center justify-center h-full rounded-full"
              style={{ width: `${progressPercentageUSD}%` }}
            >
              {progressPercentageUSD.toFixed(2)}%
            </div>
          </div>
          <div className="progressbar_goal">
            <div className="progressbar_goal_item">
              <span>Goal</span>
              <p>$15,000</p>
            </div>
            <div className="progressbar_goal_item">
              <span>Koontribution</span>
              <p>
                {balanceKOON.toLocaleString()} KOON ($
                {balanceKOONUSD.toFixed(2)})
              </p>
            </div>
          </div>
        </div>

        <div className="sendKas_container">
          <h3 className="progressbar_title">
            Send KAS or KOON to this address:
          </h3>

          <div className="sendKas">
            <span>{address}</span>
            <svg
              onClick={handleCopy}
              height="32px"
              viewBox="0 -960 960 960"
              width="32px"
              fill="undefined"
            >
              <path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z" />
            </svg>
          </div>
        </div>

        <WalletConnect />
      </div>

      <div className="leaderboard_txt_container">
        <div className="leaderboard_txt">
          Support our project and unlock exclusive KRC721 NFTs, designed for our
          community and soon to be available on the blockchain! Based on your
          donation level, you can receive one of four unique NFTs, each with
          special benefits in our upcoming game developed by the team.
        </div>

        <ul className="txt leaderboard_list">
          <li>Common Koon NFT</li>
          <li>Rare Koon NFT</li>
          <li>Epic Koon NFT</li>
          <li>Legendary Koon NFT</li>
        </ul>

        <div className="leaderboard_txt">
          Each KRC721 NFT represents a key to unlocking a richer experience in
          the Koon universe. Join us in shaping the future of our project, and
          earn your place in the adventure!
        </div>
      </div>

      <Leaderboard />
    </div>
  );
};

export default ProgressBar;
